export default __webpack_public_path__ + "static/media/eb-ultra-pro-3.26254781.png";